/* eslint-disable dot-notation */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";

import { TestBase } from "../../components/TestComponents/TestBase";
import { siteLocationPrefix } from "../../constants";
import { OnboardingHubUser } from "../../models/user";
import {
  ICrmIdAzureManager,
  ICrmIdXboxManager,
  ICrmPitchManager,
} from "../../server/crm/api/utils/CrmEntityManager";
import { CrmEntity, EntityName } from "../../server/crm/dataService";

const TestConsolePage = () => {
  const [userInfo, setUserInfo]: [OnboardingHubUser | undefined, any] = useState(undefined);
  const [_idXboxData, setIdXboxData]: [ICrmIdXboxManager | undefined, any] = useState(undefined);
  const [_idAzureData, setIdAzureData]: [ICrmIdAzureManager | undefined, any] = useState(undefined);
  const [_pitchData, setPitchData]: [ICrmPitchManager | undefined, any] = useState(undefined);
  const [account, setAccount]: [CrmEntity<EntityName.account>[] | undefined, any] =
    useState(undefined);
  const [testLogs, setTestLogs]: [string[] | undefined, any] = useState([]);
  const [gameConcepts, setGameConcepts]: [
    CrmEntity<EntityName.gaming_gameconcept>[] | undefined,
    any,
  ] = useState(undefined);
  const [pitchConcepts, setPitchConcepts]: [CrmEntity<EntityName.ggp_strike>[] | undefined, any] =
    useState(undefined);
  const [contact, setContact]: [ICrmPitchManager | undefined, any] = useState(undefined);
  const [onboardingHubProfile, setOnboardingHubProfile]: [
    CrmEntity<EntityName.gaming_onboardinghubprofile> | undefined,
    any,
  ] = useState(undefined);
  const [onboarding, setOnboarding]: [CrmEntity<EntityName.gaming_onboarding> | undefined, any] =
    useState(undefined);
  const [idAzure, setIdAzure]: [CrmEntity<EntityName.gaming_idazure> | undefined, any] =
    useState(undefined);
  const [pitch, setPitch]: [CrmEntity<EntityName.gaming_pitchprogram> | undefined, any] =
    useState(undefined);
  const [ogcEnvUrl, setOgcEnvUrl]: [string, any] = useState("");
  const [hide, setHide] = useState(true);

  useEffect(() => {
    const getData = async () => {
      const response = await fetch(`${siteLocationPrefix}/test/test-data`);
      if (response.status !== 200) {
        setHide(true);
        return;
      }
      const responseObject = await response.json();

      setUserInfo(responseObject["userInfo"]);
      setIdXboxData(responseObject["idXboxData"]);
      setAccount(responseObject["account"]);
      setIdAzureData(responseObject["idAzureData"]);
      setPitchData(responseObject["pitchData"]);
      setGameConcepts(responseObject["gameConcepts"]);
      setPitchConcepts(responseObject["pitchConcepts"]);
      setContact(responseObject["contact"]);
      setOnboardingHubProfile(responseObject["onboardingHubProfile"]);
      setOnboarding(responseObject["onboarding"]);
      setIdAzure(responseObject["idAzure"]);
      setPitch(responseObject["pitch"]);
      setOgcEnvUrl(responseObject["ogcEnvURL"]);
      setTestLogs(responseObject["testLogs"]);

      setHide(false);
    };
    getData();
  }, []);

  return (
    <>
      {!hide && (
        <TestBase
          userInfo={userInfo}
          gameConcepts={gameConcepts}
          pitchConcepts={pitchConcepts}
          contact={contact}
          account={account}
          onboardingHubProfile={onboardingHubProfile}
          onboarding={onboarding}
          idAzure={idAzure}
          pitch={pitch}
          ogcEnvURL={ogcEnvUrl}
          testLogs={testLogs}
        />
      )}
    </>
  );
};

export default TestConsolePage;
